import * as t from "io-ts";
import { createCargoTypes } from "./cargo";
import { CargoExtraCo2BaseT } from "./cargo-extra-co2";
import nullable from "./nullable";
import { withFallback } from "io-ts-types";
export const createClientCargoTemplateTypes = ({ decimal, date, dateTime, }) => {
    const { baseCargoWithoutRefT, stopT, addStopUnitT, editStopUnitInputT, editStopUnitOutputT, createCargoInvoiceLineT, } = createCargoTypes({
        decimal,
        date,
        dateTime,
    });
    const postClientCargoTemplateT = t.intersection([
        baseCargoWithoutRefT,
        t.strict({
            pickupList: t.array(stopT),
            dropoffList: t.array(stopT),
            stopUnits: withFallback(t.array(addStopUnitT), []),
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
            invoiceLines: t.array(createCargoInvoiceLineT),
        }),
    ]);
    const idT = t.strict({ id: t.string });
    const optionalIdT = t.partial({ id: t.string });
    const editStopOutputT = t.intersection([stopT, idT]);
    const editStopInputT = t.intersection([stopT, optionalIdT]);
    const editClientCargoTemplateOutputT = t.intersection([
        baseCargoWithoutRefT,
        idT,
        t.strict({
            createdAt: dateTime,
            deliveryId: t.string,
            createdByUserId: nullable(t.string),
            canBeDeleted: t.boolean,
            pickupList: t.array(editStopOutputT),
            dropoffList: t.array(editStopOutputT),
            stopUnits: t.array(editStopUnitOutputT),
            totalLm: decimal,
            totalWeight: nullable(decimal),
            revision: t.string,
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
            hasBeenSplit: t.boolean,
            originalRouteIdBeforeSplit: nullable(t.string),
            splitFromCargoId: nullable(t.string),
        }),
    ]);
    const editClientCargoTemplateInputT = t.intersection([
        baseCargoWithoutRefT,
        t.strict({
            pickupList: t.array(editStopInputT),
            dropoffList: t.array(editStopInputT),
            stopUnits: withFallback(t.array(editStopUnitInputT), []),
            extraCo2Elements: t.array(CargoExtraCo2BaseT),
        }),
        t.exact(t.partial({
            invoiceLines: t.array(createCargoInvoiceLineT),
        })),
    ]);
    const createClientCargoTemplateReqT = t.strict({
        name: t.string,
        cargoIdToCopyInvoiceLinesFrom: nullable(t.string),
        cargoIdToCopyFilesFrom: nullable(t.string),
        data: postClientCargoTemplateT,
    });
    const createClientCargoTemplateResT = t.strict({
        id: t.string,
        cargoId: t.string,
    });
    const editClientCargoTemplateReqT = t.intersection([
        t.strict({
            id: t.string,
            data: editClientCargoTemplateInputT,
        }),
        t.exact(t.partial({
            cargoIdToCopyInvoiceLinesFrom: t.string,
        })),
    ]);
    const getClientsCargoTemplatesResT = t.array(t.strict({
        id: t.string,
        name: t.string,
        cargoId: t.string,
        clientId: t.string,
        teamId: t.string,
    }));
    const getClientCargoTemplateResT = t.strict({
        id: t.string,
        name: t.string,
        cargoId: t.string,
        data: editClientCargoTemplateOutputT,
    });
    return {
        createClientCargoTemplateReqT,
        editClientCargoTemplateReqT,
        getClientsCargoTemplatesResT,
        getClientCargoTemplateResT,
        createClientCargoTemplateResT,
    };
};
//# sourceMappingURL=client-cargo-template.js.map